<div
  class="note-container"
  [ngClass]="{
    me: note?.author?.id === me.id,
  }">
  <div class="note-picture">
    <iu-avatar-ui [avatarInfos]="note.author" />
  </div>
  <div class="note-content" data-cy="note-content">
    <div class="note-title">
      @if (note?.author?.id !== me.id) {
        <h4 class="note-author">
          {{ note?.author?.fullname ?? ('notes.unknownAuthor' | translate) }}
        </h4>
      }
      <span class="note-date">
        {{ note?.createdAt }}
      </span>
    </div>
    <div class="note-text">
      <iu-input-mention-ui
        [content]="note?.content"
        [tagifyOptions]="{ pattern: null, enforceWhitelist: false, placeholder: null }"
        [type]="'text'" />
    </div>
    <!-- <div class="note-images"></div> -->
    <div class="note-attachments">
      @for (attachment of note?.attachements; track attachment) {
        <div class="note-attachment" [title]="attachment?.filename">
          <i
            aria-hidden="true"
            class="{{ attachment?.filename | docIcon }}"
            (click)="parent.downloadEntryAttachment(attachment)"></i>
          <span>{{ attachment?.filename }}</span>
        </div>
      }
    </div>
  </div>
</div>
